module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sky-sharethis",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.share($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-0d7f8968"}!F:/Solutions/6713ge/master/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/sky-sharethis/sky-sharethis.vue
// module id = 339
// module chunks = 1